import Vue from 'vue'
import Router from 'vue-router'

import NotFound from '@/components/404'
import Home from '@/components/Home'
import AdminUpdateData from '@/components/AdminUpdateData'
import MigrateData from '@/components/MigrateData'
import Search from '@/components/search'
import BrowseGrapevines from '@/components/BrowseGrapevines'
import MyGrapevines from '@/components/MyGrapevines'
import Grapevine from '@/components/Grapevine'
import TopRated from '@/components/TopRated'
import Author from '@/components/Author'
import Book from '@/components/Book'
import User from '@/components/User'
import ViewGrape from '@/components/ViewGrape'
import ViewGrapeShareImage from '@/components/ViewGrapeShareImage'
import EditGrape from '@/components/EditGrape'
import NewGrape from '@/components/NewGrape'
import Account from '@/components/Account'
import PrivacyPolicy from '@/components/PrivacyPolicy'

import AdminGrapesAdmin from '@/components/admin/grapesAdmin'
import AdminFlagsAdmin from '@/components/admin/grapeFlags'
import AdminGrapevinesAdmin from '@/components/admin/grapevinesAdmin'
import AdminGrapevineAdmin from '@/components/admin/grapevineAdmin'
import AdminOCRAdmin from '@/components/admin/ocrAdmin'
import AdminListsAdmin from '@/components/admin/listsAdmin'
import AdminMailchimpAdmin from '@/components/admin/mailchimpAdmin'
import AdminTwitterAdmin from '@/components/admin/twitterAdmin'
import GrapeEmailDraft from '@/components/admin/grapeEmailDraft'

// Press
import PrintPublication from '@/components/Publication'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    { path: '*', component: NotFound },
    { path: '/', name: 'home', component: Home },
    { path: '/adminupdatedata', name: 'adminupdatedata', component: AdminUpdateData },
    { path: '/migratedata', name: 'migratedata', component: MigrateData },
    { path: '/search/:term', name: 'search', component: Search },
    { path: '/browse-grapevines', name: 'browse-grapevines', component: BrowseGrapevines },
    { path: '/your-grapevines', name: 'your-grapevines', component: MyGrapevines },
    { path: '/grapevine/:id/:name', name: 'grapevine', component: Grapevine, props: (route) => ({grapeID: route.query.grapeID})},
    { path: '/top-rated', name: 'top-rated', component: TopRated },
    { path: '/u/:username', name: 'user', component: User },
    { path: '/author/:name', name: 'author', component: Author },
    { path: '/book/:title/:id', name: 'book', component: Book },
    { path: '/add', name: 'new-grape', component: NewGrape },
    { path: '/account', name: 'account', component: Account },
    { path: '/privacy-policy', name: 'privacy-policy', component: PrivacyPolicy },
    { path: '/view-grape/:grapeID', name: 'view-grape', component: ViewGrape },
    { path: '/view-grape-share/:grapeID', name: 'view-grape=share', component: ViewGrapeShareImage },
    { path: '/edit-grape/:grapeID', name: 'edit-grape', component: EditGrape },
    { path: '/admin/grapes', name: 'admin-grapes', component: AdminGrapesAdmin },
    { path: '/admin/flags', name: 'admin-flags', component: AdminFlagsAdmin },
    { path: '/admin/grapevines', name: 'admin-grapevines', component: AdminGrapevinesAdmin },
    { path: '/admin/grapevine/:id/:name', name: 'admin-grapevine', component: AdminGrapevineAdmin },
    { path: '/admin/ocr', name: 'admin-ocr', component: AdminOCRAdmin },
    { path: '/admin/lists', name: 'admin-lists', component: AdminListsAdmin },
    { path: '/admin/mailchimp', name: 'admin-mailchimp', component: AdminMailchimpAdmin },
    { path: '/admin/twitter', name: 'admin-twitter', component: AdminTwitterAdmin },
    { path: '/admin/grape-draft/:grapeID', name: 'grape-email-draft', component: GrapeEmailDraft },

    // Pro
    { path: '/print', name: 'print-home', component: Home },
    { path: '/print/search/:term', name: 'print-search', component: Search },
    { path: '/print/view-grape/:grapeID', name: 'print-view-grape', component: ViewGrape },
    { path: '/publication/:name', name: 'publication', component: PrintPublication },
    { path: '/print/grapevine/:id/:name', name: 'print-grapevine', component: Grapevine },
    { path: '/print/author/:name', name: 'print-author', component: Author },
    { path: '/print/browse-grapevines', name: 'print-browse-grapevines', component: BrowseGrapevines },
    { path: '/print/your-grapevines', name: 'print-your-grapevines', component: MyGrapevines },
    { path: '/print/u/:username', name: 'print-user', component: User },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js